import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { motion } from "framer-motion";
import { LayoutDashboard, LogOut, Sparkles } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  return (
    <motion.div
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="sticky top-4 z-50 mx-auto w-[min(96%,1180px)] mt-4"
    >
      <div className="kd-glass rounded-full flex items-center justify-between px-5 py-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <img
            src="/klickdeck-logo.png"
            alt="KlickDeck"
            className="h-7 md:h-8 w-auto select-none"
            draggable={false}
          />
        </Link>
        <div className="hidden md:flex items-center gap-8 text-sm text-zinc-400">
          <a href="/#features" className="hover:text-white transition-colors" data-testid="nav-features">Features</a>
          <a href="/#pricing" className="hover:text-white transition-colors" data-testid="nav-pricing">Pricing</a>
          <a href="/#faq" className="hover:text-white transition-colors" data-testid="nav-faq">FAQ</a>
        </div>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              <button
                onClick={() => nav("/dashboard")}
                data-testid="nav-dashboard"
                className="rounded-full px-4 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 transition-colors flex items-center gap-2"
              >
                <LayoutDashboard size={14} /> Dashboard
              </button>
              {user.is_admin && (
                <button
                  onClick={() => nav("/admin")}
                  data-testid="nav-admin"
                  className="rounded-full px-4 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 transition-colors"
                >
                  Admin
                </button>
              )}
              <button
                onClick={() => { logout(); nav("/"); }}
                data-testid="nav-logout"
                className="rounded-full p-2 bg-white/5 hover:bg-white/10 border border-white/10 transition-colors"
                title="Log out"
              >
                <LogOut size={14} />
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => nav("/auth")}
                data-testid="nav-signin"
                className="hidden sm:inline-flex rounded-full px-4 py-2 text-sm bg-white/5 hover:bg-white/10 border border-white/10 transition-colors"
              >
                Sign in
              </button>
              <button
                onClick={() => nav("/create")}
                data-testid="nav-cta"
                className="rounded-full px-4 py-2 text-sm bg-[#E50914] hover:bg-[#FF2A2D] text-white transition-all duration-300 flex items-center gap-2 hover:shadow-[0_0_24px_rgba(229,9,20,0.55)]"
              >
                <Sparkles size={14} /> Generate my deck
              </button>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
}
